export const ADMIN_CLAIM_KEY = "admin";

export const ADMIN_CONFIG_PATHS = {
  runtime: "adminConfigs/runtime",
  navigation: "adminConfigs/navigation",
  scroller: "adminConfigs/scroller",
  rules: "adminConfigs/rules",
  nameConfig: "adminConfigs/lc_name_cfg",
  nameReviewQueue: "adminConfigs/lc_name_review_queue",
  witAudit: "adminConfigs/witAudit",
  witConfig: "adminConfigs/witConfig",
  witTrainingQueue: "adminConfigs/witTrainingQueue",
};
